import React from "react";
import { Badge } from "antd";
import styles from "./styles.module.css";

const ProjectStatuses = [
  {
    id: 1,
    name: "انجام نشده",
    color: "#faad14",
    status: "warning",
  },
  {
    id: 2,
    name: "در حال انجام",
    color: "#1677ff",
    status: "processing",
  },
  {
    id: 3,
    name: "انجام شده",
    color: "#52c41a",
    status: "success",
  },
];
const FactorStatuses = [
  {
    id: 1,
    name: "انجام نشده",
    color: "#faad14",
    status: "warning",
  },
  {
    id: 2,
    name: "در حال انجام",
    color: "#1677ff",
    status: "processing",
  },
  {
    id: 3,
    name: "انجام شده",
    color: "#52c41a",
    status: "success",
  },
];

const StatusBadge = ({ status }) => {
  const currentStatus = FactorStatuses.filter((item) => item.id === status)[0];
  if (!currentStatus) return null;

  return (
    <div
      className={`${styles.badge} ${status === 2 ? styles.pulse : ""}`}
      style={{ "--status-color": currentStatus.color }}
    >
      <Badge count={currentStatus.name} color={currentStatus.color} />
    </div>
  );
};

export { FactorStatuses, ProjectStatuses, StatusBadge };
